import { DisplayInfoFromJSON, DisplayInfoToJSON, } from './DisplayInfo';
import { TicketTemplateManagementInfoFromJSON, TicketTemplateManagementInfoToJSON, } from './TicketTemplateManagementInfo';
/**
 * Check if a given object implements the CreateTicketTemplateRequest interface.
 */
export function instanceOfCreateTicketTemplateRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "expirationInDays" in value;
    isInstance = isInstance && "permitId" in value;
    isInstance = isInstance && "displayInfo" in value;
    isInstance = isInstance && "managementInfo" in value;
    return isInstance;
}
export function CreateTicketTemplateRequestFromJSON(json) {
    return CreateTicketTemplateRequestFromJSONTyped(json, false);
}
export function CreateTicketTemplateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'expirationInDays': json['expirationInDays'],
        'permitId': json['permitId'],
        'displayInfo': DisplayInfoFromJSON(json['displayInfo']),
        'managementInfo': TicketTemplateManagementInfoFromJSON(json['managementInfo']),
    };
}
export function CreateTicketTemplateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'expirationInDays': value.expirationInDays,
        'permitId': value.permitId,
        'displayInfo': DisplayInfoToJSON(value.displayInfo),
        'managementInfo': TicketTemplateManagementInfoToJSON(value.managementInfo),
    };
}
